import {Place} from "types/Place";
import {dateTime} from "services/date";

/**
 * Transform the given place by deserializing object properties
 *
 * @internal
 * @param place
 */
export default function deserializePlace(place: any): Place {
    place.created_at = dateTime(place.created_at)
    place.updated_at = dateTime(place.updated_at)

    return place;
}